import { Actions } from '../actions/Actions';
import { Container } from '../Models/Container';
import { combineReducers } from 'redux';
import { signedInUserReducer } from './signedInUserReducer';
import dashboardReducer from './dashboardReducer';
import actionReducer from './actionReducer';
import viewReducer from './viewReducer';
import bannerReducer from './bannerMessageReducer';

export const loadWorkItems = (state: any, action: any) => {
  switch (action.type) {
    case Actions.LOAD_WORKITEMS:
      const newState = new Container();
      return {
        ...newState,
        state,
      };
    default:
      return {};
  }
};

const rootReducer = combineReducers({
  loadWorkItems,
  signedInUserReducer,
  dashboardReducer,
  actionReducer,
  viewReducer,
  bannerReducer,
});

export default rootReducer;
